var MDB = window.MDB || {};
MDB.Charts = MDB.Charts || {};
MDB.Charts.renderers = MDB.Charts.renderers || {};

MDB.Charts.renderers.progressGauge = function (widget, chart, data, metadata) {
    //Todo: Make widget generic

    //The guage animation bugs at an exact 180 degrees, so we use the closest possible value
    var spinnerTotalDegrees = 179.99999;
    
    widget.find('.loading-box').hide();
    MDB.Charts.emptyChartAndMakeVisible(widget, chart);

    var wrapper = $('<div class="progress-gauge-container">'
         + '    <div class="gauge-cont">'
         + '        <div class="gauge">'
         + '            <div class="inner"></div>'
         + '        </div>'
         + '        <div class="pointer"></div>'
         + '        <div class="pointer-knob">'
         + '            <div class="pointer-knob-inner"></div>'
         + '        </div>'
         + '    </div>'
        + '</div>')
        .appendTo(chart);    

    var gaugeContainer = wrapper.find('.gauge-cont')
        , gauge = gaugeContainer.find('.gauge')
        , spinner = gaugeContainer.find('.spinner')
        , pointer = gaugeContainer.find('.pointer')
        , pointerKnob = gaugeContainer.find('.pointer-knob')
        , pointerKnobInner = pointerKnob.find('.pointer-knob-inner')
        , spinnerConfigs = metadata.KendoConfig.gaugeConfig.spinners
        , spinnerPartDegrees = spinnerTotalDegrees / spinnerConfigs.length
        , percentage = data[0][Object.keys(data[0])[0]]
        , pointerDegrees;

    setTimeout(function () {
        pointer.css({
            transform: 'rotate(' + spinnerTotalDegrees / 2 + 'deg)'
        });
    }, 0);

    spinnerConfigs.reverse().forEach(function (config, i) {
        var spinner = $('<div />', { class: 'spinner' })
            .css({
                'background-color': config.color,
                'border-bottom-color': config.color
            })
            .appendTo(gauge); 

        var spinnerDegrees = spinnerTotalDegrees - spinnerPartDegrees * i
            , labelDegrees = spinnerDegrees - 72 - spinnerPartDegrees;

        //Check if we have an uneven amount of spinners, used for 'calculating' the middle label position
        if (spinnerConfigs.length % 2 !== 0) {
            if ((i + 1) === Math.round(spinnerConfigs.length / 2)) {
                labelDegrees = 0;
            }
        }

        spinner.css({
            transform: 'rotate(' + spinnerDegrees + 'deg)'
        });

        var spinnerPercentage = (spinnerDegrees / spinnerTotalDegrees) * 100;

        //In case we do get a 180 degree value, use the first display value we get
        if (i == 0 || percentage <= spinnerPercentage) {
            pointer.css({
                'border-bottom-color': config.color
            });

            pointerKnob.css({
                'background-color': config.color,
                'border-bottom-color': config.color
            }); 

            pointerKnobInner.css({
                'background-color': config.knobColor,
                'border-bottom-color': config.knobColor
            });
            
            pointerDegrees = (spinnerDegrees - (spinnerPartDegrees / 2)) - 90;
        }

        (function (i, name) {
            var lbl = $('<div /> ', {
                class: 'spinner-label',
                css: {
                    'transform': 'rotate(' + labelDegrees + 'deg)'
                }
            })
                .text(name)
                .appendTo(wrapper);

            setTimeout(function () {
                switch (i) {
                case 4: lbl.css({ top: '55%', left: '-15%' }); break;
                case 3: lbl.css({ top: '10%', left: '0%' }); break;
                case 2: lbl.css({ top: '-10%', left: '30%' }); break;
                case 1: lbl.css({ top: '10%', left: '75%' }); break;
                case 0: lbl.css({ top: '55%', left: '90%' }); break;
                default: break;
                }
            }, 0);
        })(i, config.text);
    });
    
    setTimeout(function () {
        pointer.css({
            transform: 'rotate(' + pointerDegrees + 'deg)'
        });
    }, 1000);
}